
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import Address from "../../Common/Address";
import PersonIcon from "@mui/icons-material/Person";
import { addCustomer, updateCustomer, getCustomerDetails, getPaymentTermKeyValuePair, getStateRegionKeyValuePair, getSalesPriceKeyValuePair } from "../../../services/index";
import { Spinner } from "react-bootstrap";
import Button from "@mui/material/Button";
import { CUSTOMER_CATEGORY_URL, CATEGORY_URL } from "../../../CONSTANTS";
import { callGetAxios } from "../../../services/common/common";

const CustomerNew = () => {
    let { id } = useParams();
    let navigate = useNavigate();
    const [discount, setDiscount] = useState(0);
    const [categoryOptions, setCategoryOptions] = useState([{ value: "All", label: "All" }]);
    const [discountRows, setDiscountRows] = useState([
        { discount: 0, discountType: { value: "None", label: "None" }, category: { value: "All", label: "All" } }
    ]);
    const discountTypeOptions = [
        { value: "Percentage", label: "Percentage" },
        { value: "None", label: "None" },
    ];

    const RegistrationTypeOptions = [
        { value: "Regular", label: "Regular" },
        { value: "Unregistered", label: "Unregistered" },
    ]

    const storedValueObj = {
        gst: "",
    }
    const [priceListOptions, setPriceListOptions] = useState([]);
    const [customerCatOptions, setCustomerCatOptions] = useState([]);
    const [payTermOptions, setPayTermOptions] = useState([]);
    const [placeOptions, setPlaceOptions] = useState("");
    const [loading, setLoading] = useState(false);
    const [storedValue, setStoredValue] = useState(storedValueObj);
    const [customerInfo, setCustomerInfo] = useState({
        name: "",
        email: "",
        phone: "",
        gst: "",
        fssai: 1,
        fssaiValidateDate: '',
        place: "",
        priceList: "",
        customerCategory: "",
        payTerm: "",
        remark: "",
        type: "Business",
        tcsApplicable: false,
        gstRegistrationTypeEnum: { value: "Regular", label: "Regular" }
    });

    const [child1, setChild1] = useState({
        addressType: "Billing",
        country: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        pinCode: "",
    });

    const [child2, setChild2] = useState({
        addressType: "Shipping",
        country: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        pinCode: "",
    });

    const handleCopy = (d) => {
        d.addressType = "Shipping";
        setChild2(d);
    };

    const handleData = (e, key) => {
        if (key === "tcsApplicable") {
            setCustomerInfo({
                ...customerInfo,
                tcsApplicable: e.target.checked,
            });
        } else if (e.value && e.label) {
            setCustomerInfo({
                ...customerInfo,
                [key]: e,
            });
        } else if (e.target.value) {
            setCustomerInfo({
                ...customerInfo,
                [e.target.name]: e.target.value,
            });
        } else {
            setCustomerInfo({
                ...customerInfo,
                [e.target.name]: "",
            });
        }
      
    };

    const handleChild1 = (e, key) => {
        if (e.value && e.label) {
            setChild1({
                ...child1,
                [key]: e,
            });
        } else if (e.target.value) {
            setChild1({
                ...child1,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleChild2 = (e, key) => {
        if (e.value && e.label) {
            setChild2({
                ...child2,
                [key]: e,
            });
        } else if (e.target.value) {
            setChild2({
                ...child2,
                [e.target.name]: e.target.value,
            });
        }
    };

    useEffect(() => {
        if (id) {
            getCustomer();
        }
        getStateRegionKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const data = res.responsePacket;
                const options = data.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setPlaceOptions(options);
            } else {
                toast(res.message);
            }
        });

        getSalesPriceKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const data = res.responsePacket;
                const options = data.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setPriceListOptions(options);
            } else {
                toast(res.message);
            }
        });

        const getCustomerCategoryKeyValuePairs = async () => {
            try {
                const rUrl = CUSTOMER_CATEGORY_URL() + "getKeyValueList"
                const res = await callGetAxios(rUrl)
                if (res.errorCode === 0) {
                    const options = res.responsePacket.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setCustomerCatOptions(options);
                }
            } catch (error) {
                console.error(error)
            }
        }
        getCustomerCategoryKeyValuePairs();

        const getCategoryKeyValuePairs = async () => {
            try {
                const rUrl = CATEGORY_URL() + "getKeyValueList";
                const res = await callGetAxios(rUrl);
                if (res.errorCode === 0) {
                    const options = [
                        { value: "All", label: "All" },
                        ...res.responsePacket.map((d) => ({ value: d.key, label: d.value }))
                    ];
                    setCategoryOptions(options);
                }
            } catch (error) {
                console.error(error);
            }
        };
        getCategoryKeyValuePairs();

        getPaymentTermKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const data = res.responsePacket;
                const options = data.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setPayTermOptions(options);
            } else {
                toast(res.message);
            }
        });
    }, []);


    useEffect(() => {
        if (customerInfo?.gstRegistrationTypeEnum?.value === storedValue?.selectedKey) {
            setCustomerInfo((prev) => ({
                ...prev,
                gst: storedValue?.gst
            }));
        } else {
            setCustomerInfo((prev) => ({
                ...prev,
                gst: ""
            }));
        }
    }, [customerInfo?.gstRegistrationTypeEnum]);


    const getCustomer = () => {
        getCustomerDetails(id)
            .then((res) => {
                if (res.errorCode === 0) {
                    const dd = res.responsePacket;
                    if (res.responsePacket?.discountValue === "") {
                        setDiscount(0);
                    } else {
                        setDiscount(res.responsePacket?.discountValue);
                    }

                    let d = res.responsePacket.addressList;

                    let child1 = d.filter((a) => a.addressType === "Billing");
                    child1.map((a) => {
                        a.country = { value: "c", label: a.country };
                        a.state = { value: "b", label: a.state };
                    });

                    let child2 = d.filter((a) => a.addressType === "Shipping");
                    child2.map((a) => {
                        a.country = { value: "c", label: a.country };
                        a.state = { value: "b", label: a.state };
                    });
                    let a1 = child1[0];
                    let a2 = child2[0];

                    if (a1 !== undefined) {
                        setChild1(a1);
                    }
                    if (a2 !== undefined) {
                        setChild2(a2);
                    }

                    const _gstRegistrationTypeEnum = RegistrationTypeOptions.find((item) => item.value === dd.gstRegistrationTypeEnum);
                    setStoredValue((prev) => ({
                        ...prev,
                        gst: dd.gstNumber,
                        selectedKey: dd.gstRegistrationTypeEnum
                    }))
                    if (dd.categoryDiscountList && dd.categoryDiscountList.length > 0) {
                        setDiscountRows(dd.categoryDiscountList.map((item) => ({
                            discount: item.discountValue,
                            discountType: { value: item.discountType, label: item.discountType },
                            category: item.categoryId
                                ? { value: item.categoryId, label: item.categoryTitle }
                                : { value: "All", label: "All" },
                        })));
                    } else {
                        setDiscountRows([{
                            discount: dd.discountValue,
                            discountType: { value: dd.discountType, label: dd.discountType },
                            category: { value: "All", label: "All" },
                        }]);
                    }
                    setCustomerInfo({
                        recordId: dd.recordId,
                        type: dd.customerType,
                        name: dd.title,
                        email: dd.email,
                        phone: dd.phone,
                        fssai: dd.fssaiLicenseNumber === 0 ? 1 : dd.fssaiLicenseNumber,
                        fssaiValidateDate: dd.fssaiValidateDate,
                        // gst: dd.gstNumber,
                        remark: dd.remark,
                        tcsApplicable: dd.tcsApplicable,
                        gstRegistrationTypeEnum: _gstRegistrationTypeEnum,
                        place: {
                            value: dd.placeOfSupply,
                            label: dd.placeOfSupplyTitle,
                        },
                        payTerm: {
                            value: dd.paymentTermRecordId,
                            label: dd.paymentTermTitle,
                        },
                        priceList: {
                            value: dd.itemPriceListRecordId,
                            label: dd.itemPriceListTitle,
                        },
                        customerCategory: {
                            value: dd.customerCategoryId,
                            label: dd.customerCategory,
                        },
                    });
                } else {
                    toast(res.message);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };


    const handleSaveCustomer = () => {
        let ar = [];

        var deepCopy1 = JSON.parse(JSON.stringify(child1));
        var deepCopy2 = JSON.parse(JSON.stringify(child2));

        deepCopy1.state = child1?.state?.label;
        deepCopy1.country = child1?.country?.label;
        deepCopy1.isAdditionalAddress = false;

        deepCopy2.state = child2?.state?.label;
        deepCopy2.country = child2?.country?.label;
        deepCopy2.isAdditionalAddress = false;

        ar.push(deepCopy1);
        ar.push(deepCopy2);
        if (ar.length !== 2) {
            toast("billing/ shipping Address empty");
            return;
        }

        if (!child1.country.label || !child2.country.label) {
            toast("Please select both country");
            return;
        }
        if (!child1.state.label || !child2.state.label) {
            toast("Please select both state");
            return;
        }
        if (!child1.city || !child2.city) {
            toast("Please select both city");
            return;
        }
        if (!child1.pinCode || !child2.pinCode) {
            toast("Please select both pinCode");
            return;
        }
        if (!child1.addressLine1 || !child2.addressLine1) {
            toast("Please select both addressLine1");
            return;
        }
        if (!child1.addressLine2 || !child2.addressLine2) {
            toast("Please select both addressLine2");
            return;
        }

        if (!customerInfo.name) {
            toast("Please select Company's Name");
            return;
        }
        if (!customerInfo.phone || (customerInfo?.phone).toString().length !== 10) {
            toast("Please enter 10 Digit phone");
            return;
        }
        if (!customerInfo.fssaiValidateDate) {
            toast("Please provide FSSAI Date");
            return;
        }

        if (customerInfo.gstRegistrationTypeEnum.value === "Regular") {
            if (!customerInfo.gst || (customerInfo?.gst).toString().length !== 15) {
                toast("Please enter 15 Digit GST");
                return;
            }
        }

        if (!customerInfo.customerCategory) {
            toast("Please select customer category");
            return;
        }

        setLoading(true);

        const hasSpecificCategory = discountRows.some((row) => row.category?.value !== "All");
        const topLevelDiscountType = !hasSpecificCategory
            ? (discountRows[0]?.discountType?.value || "None")
            : "None";
        const topLevelDiscountValue = !hasSpecificCategory
            ? (discountRows[0]?.discountType?.value === "None" || discountRows[0]?.discount === "" ? 0 : Number(discountRows[0]?.discount))
            : 0;
        const categoryDiscountList = hasSpecificCategory
            ? discountRows
                .filter((row) => row.category?.value !== "All")
                .map((row) => ({
                    categoryId: row.category?.value,
                    categoryTitle: row.category?.label,
                    discountValue: row.discountType?.value === "None" || row.discount === "" ? 0 : Number(row.discount),
                    discountType: row.discountType?.value || "None",
                }))
            : null;

        var request = {
            salutation: "Mr",
            gstTreatmentTypeEnum: "GSTINUIN",
            gstTreatmentRecordId: "0a66bb0b-36e1-4ef2-b892-a4e04b623e71",
            currencyRecordId: "dad7fa51-f498-42fb-a2d9-8efe52269ffc",
            currencyRecordTitle: "INR - Indian Rupee",

            discountType: topLevelDiscountType,
            discountValue: topLevelDiscountValue,
            categoryDiscountList: categoryDiscountList,
            isDiscountApplicable: !hasSpecificCategory,
            addressList: ar,
            companyTitle: customerInfo.name?.trim(),
            fullName: customerInfo.name?.trim(),
            title: customerInfo.name?.trim(),
            customerType: customerInfo.type,
            email: customerInfo.email?.trim(),
            phone: customerInfo.phone,
            taxApplicable: true,
            placeOfSupply: customerInfo.place.value,
            placeOfSupplyTitle: customerInfo.place.label,
            gstNumber: customerInfo.gstRegistrationTypeEnum.value === "Unregistered" ? "URP" : customerInfo.gst,
            itemPriceListRecordId: customerInfo.priceList.value,
            itemPriceListTitle: customerInfo.priceList.label,
            customerCategoryId: customerInfo.customerCategory.value,
            gstRegistrationTypeEnum: customerInfo.gstRegistrationTypeEnum.value,
            customerCategory: customerInfo.customerCategory.label,
            paymentTermRecordId: customerInfo.payTerm.value,
            paymentTermTitle: customerInfo.payTerm.label,
            remark: customerInfo.remark,
            tcsApplicable: customerInfo.tcsApplicable,
            fssaiLicenseNumber: customerInfo.fssai,
            fssaiValidateDate: customerInfo.fssaiValidateDate,
        };

        if (id) {
            updateCustomer(id, request)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast(res.message);
                        setLoading(false);
                        navigate("/contacts");
                    } else {
                        toast(res.message);
                        setLoading(false);
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        } else {
            addCustomer(request)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast(res.message);
                        setLoading(false);
                        navigate("/contacts");
                    } else {
                        toast(res.message);
                        setLoading(false);
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        }
    };

    const handleDiscountRowChange = (index, field, value) => {
        const updated = discountRows.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        );
        setDiscountRows(updated);
    };

    const addDiscountRow = () => {
        setDiscountRows([...discountRows, { discount: 0, discountType: { value: "None", label: "None" }, category: { value: "All", label: "All" } }]);
    };

    const removeDiscountRow = (index) => {
        setDiscountRows(discountRows.filter((_, i) => i !== index));
    };

    return (
        <>
            <div className="containBox">
                <div className="row1" style={{ fontSize: "16px", height: "30px" }}>
                    <PersonIcon />
                    &nbsp; New Customer
                </div>
                <br />
                <div>
                    <table className="requiredTable">
                        <tr style={{ color: "black" }}>
                            <td>Type</td>
                            <td>
                                <RadioGroup
                                    name="type"
                                    row
                                    value={customerInfo.type}
                                    onChange={(e) => {
                                        handleData(e);
                                    }}
                                >
                                    <FormControlLabel defaultChecked value="Business" control={<Radio size="small" />} label="Business" />
                                    <FormControlLabel value="Individual" control={<Radio size="small" />} label="Individual" />
                                </RadioGroup>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "150px" }}>Company's Name</td>
                            <td style={{ width: "250px" }}>
                                <input
                                    autoComplete="off"
                                    name="name"
                                    className="form-control "
                                    value={customerInfo.name}
                                    onChange={(e) => {
                                        handleData(e);
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>
                                {" "}
                                <input
                                    autoComplete="off"
                                    name="email"
                                    className="form-control "
                                    value={customerInfo.email}
                                    onChange={(e) => {
                                        handleData(e);
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Phone</td>
                            <td className="otp-spin">
                                <input
                                    autoComplete="off"
                                    name="phone"
                                    min="0"
                                    type="number"
                                    className="form-control "
                                    value={customerInfo.phone}
                                    onChange={(e) => {
                                        const limitedValue = e.target.value.slice(0, 10);
                                        setCustomerInfo({ ...customerInfo, phone: limitedValue });
                                    }}
                                // onChange={(e) => {
                                //     handleData(e);
                                // }}
                                />
                            </td>
                        </tr>
                        {discountRows.map((row, index) => (
                        <tr key={index}>
                            <td>{index === 0 ? "Discount" : ""}</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    name="discount"
                                    min="0"
                                    type="number"
                                    className="form-control"
                                    value={row.discount}
                                    onChange={(e) => handleDiscountRowChange(index, "discount", e.target.value)}
                                />
                            </td>
                            <td>
                                <Select
                                    options={discountTypeOptions}
                                    value={row.discountType}
                                    onChange={(e) => handleDiscountRowChange(index, "discountType", e)}
                                />
                            </td>
                            <td style={{ minWidth: "160px" }}>
                                <Select
                                    options={categoryOptions}
                                    value={row.category}
                                    placeholder="Category..."
                                    onChange={(e) => handleDiscountRowChange(index, "category", e)}
                                />
                            </td>
                            <td style={{ whiteSpace: "nowrap" }}>
                                <button
                                    type="button"
                                    onClick={addDiscountRow}
                                    style={{
                                        width: "28px", height: "28px", borderRadius: "4px",
                                        border: "1px solid #1976d2", background: "#1976d2",
                                        color: "#fff", fontSize: "18px", lineHeight: "1",
                                        cursor: "pointer", marginRight: "4px"
                                    }}
                                >+</button>
                                {index > 0 && (
                                    <button
                                        type="button"
                                        onClick={() => removeDiscountRow(index)}
                                        style={{
                                            width: "28px", height: "28px", borderRadius: "4px",
                                            border: "1px solid #d32f2f", background: "#d32f2f",
                                            color: "#fff", fontSize: "18px", lineHeight: "1",
                                            cursor: "pointer"
                                        }}
                                    >−</button>
                                )}
                            </td>
                        </tr>
                        ))}
                        <tr>
                            <td>Gst Registration TypeEnum</td>
                            <td>
                                <Select
                                    options={RegistrationTypeOptions}
                                    value={customerInfo?.gstRegistrationTypeEnum}
                                    onChange={(e) => {
                                        handleData(e, "gstRegistrationTypeEnum");
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>GST</td>
                            <td>
                                <input
                                    disabled={customerInfo?.gstRegistrationTypeEnum?.value === "Unregistered"}
                                    autoComplete="off"
                                    name="gst"
                                    max={15}
                                    className="form-control"
                                    value={customerInfo?.gstRegistrationTypeEnum.value === "Unregistered" ? "URP" : customerInfo?.gst}
                                    onChange={(e) => {
                                        if (customerInfo?.gstRegistrationTypeEnum.value === "Regular") {
                                            const limitedValue = e.target.value.slice(0, 15);
                                            setCustomerInfo({ ...customerInfo, gst: limitedValue });
                                        }
                                    }}
                                />
                            </td>

                        </tr>
                        <tr>
                            <td>FSSAI</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    name="fssai"
                                    className="form-control "
                                    value={customerInfo.fssai}
                                    onChange={(e) => {
                                        handleData(e);
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>FSSAI Date</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    className="form-control"
                                    type="date"
                                    name="fssaiValidateDate"
                                    value={customerInfo.fssaiValidateDate}
                                    onChange={(e) => handleData(e)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td>PriceList</td>
                            <td>
                                <Select
                                    options={priceListOptions}
                                    value={customerInfo.priceList}
                                    onChange={(e) => {
                                        handleData(e, "priceList");
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Customer Category *</td>
                            <td>
                                <Select
                                    options={customerCatOptions}
                                    value={customerInfo.customerCategory}
                                    onChange={(e) => {
                                        handleData(e, "customerCategory");
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Payment Terms</td>
                            <td>
                                <Select
                                    options={payTermOptions}
                                    value={customerInfo.payTerm}
                                    onChange={(e) => {
                                        handleData(e, "payTerm");
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Place of Supply</td>
                            <td>
                                <Select
                                    options={placeOptions}
                                    value={customerInfo.place}
                                    onChange={(e) => {
                                        handleData(e, "place");
                                    }}
                                />
                            </td>
                        </tr>
                        <tr style={{ color: "black" }}>
                            <td>Remark</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    name="remark"
                                    className="form-control "
                                    value={customerInfo.remark}
                                    onChange={(e) => {
                                        handleData(e);
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>TcsApplicable</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    type="checkbox"
                                    name=" tcsApplicable"
                                    checked={customerInfo.tcsApplicable}
                                    onChange={(e) => {
                                        handleData(e, "tcsApplicable");
                                    }}
                                />
                            </td>
                        </tr>
                    </table>

                    <Address handleChild1={handleChild1} child1={child1} handleChild2={handleChild2} child2={child2} handleCopy={handleCopy} custDetail={customerInfo} />
                    <div>
                        {loading ? (
                            <Button variant="contained">
                                <Spinner />
                            </Button>
                        ) : (
                            <Button variant="contained" onClick={handleSaveCustomer}>
                                Save
                            </Button>
                        )}
                    </div>
                </div>
            </div>

            <Toaster />
        </>
    );
};

export default CustomerNew;
